type SettingsSwitchProps = {
  id: string
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
  'aria-describedby'?: string
}

export function SettingsSwitch({
  id,
  checked,
  onCheckedChange,
  disabled = false,
  'aria-describedby': ariaDescribedBy,
}: SettingsSwitchProps) {
  return (
    <button
      type="button"
      id={id}
      role="switch"
      aria-checked={checked}
      aria-disabled={disabled || undefined}
      disabled={disabled}
      aria-describedby={ariaDescribedBy}
      onClick={() => {
        if (!disabled) onCheckedChange(!checked)
      }}
      className={`-m-2 inline-flex min-h-11 min-w-11 shrink-0 items-center justify-center rounded-full p-2 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-interactive-focus-ring ${
        disabled ? 'cursor-not-allowed opacity-50' : ''
      }`}
    >
      <span
        className={`relative inline-flex h-6 w-11 items-center rounded-full border border-border-default transition-colors ${
          checked ? 'bg-brand-primary' : 'bg-surface-muted'
        }`}
        aria-hidden="true"
      >
        <span
          className={`inline-block h-5 w-5 rounded-full bg-surface-default shadow transition-transform ${
            checked ? 'translate-x-[18px]' : 'translate-x-0.5'
          }`}
        />
      </span>
    </button>
  )
}
